export const discountedPrice = (price, discount) => {
  let pr = parseInt(price);
  let dp = parseInt(((100 - discount) / 100) * pr);
  return dp.toFixed(2);
};

export const shortenContactPersonName = (personName) => {
  let name = personName;
  let arr = name.split(" ");
  arr[arr.length - 1] = arr[arr.length - 1].substr(0, 1);
  let newName = arr.toString().replace(",", " ");
  return newName;
};

shortenContactPersonName("Kamal Singh Sharma");

// const string = "Kamal Singh Sharma".slice(0, 7).concat("...");
// const string2 = "Kamal Singh Sharma".substring(0, 7).concat("...");

//console.log(string, string2);

export const shortenString = (str, limit) => {
  if (str.length > limit) {
    return str.slice(0, limit).concat(" ...");
  } else {
    return str;
  }
};

export const changeDateFormat = (timestamp) => {
  return new Date(timestamp).toLocaleString("en-us", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const ratingCalculator = (reviews) => {
  let rate = 0;
  if (reviews?.length > 0) {
    reviews.map((review) => {
      rate = rate + review.rating;
      return rate;
    });

    let rating = rate / reviews.length;
    return rating;
  } else {
    return rate;
  }
};

export const fetchYoutubeVideoId = (videoLink) => {
  if (videoLink.includes("=")) {
    let idArray = videoLink.split("=");
    //console.log("is", idArray);
    let videoId = idArray[1];
    return videoId;
  }
};

export function outerWidth(el) {
  var width = el.offsetWidth;
  var style = getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
}

export const ordering = (a, b) => {
  if (a?.ranking > b?.ranking) {
    return 1;
  }

  if (a?.ranking < b?.ranking) {
    return -1;
  }

  return 0;
};

export const scrollToId = (id) => {
  let element = document.getElementById(id);
  element.scrollIntoView({ behavior: "smooth" });
};

export function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function getPageName(path) {
  let pageName;
  if (path === "/") {
    pageName = "home_page";
    return pageName;
  } else {
    let arr = path.split("/");
    arr.shift(); //to remove 1st element
    let newArr = arr.join("_");
    pageName = newArr + "_page";
    return pageName;
  }
}

export function trackSubscriber(email, path) {
  // let pageName = getPageName(path);
  // window.analytics.track(`subscriber_form filled from ${pageName}`, {
  //   email: email,
  //   path: `${window.location.href}`,
  // });
  // window.analytics.ready(function () {
  //   window.analytics.identify(getCookie("ajs_user_id"), {
  //     email: email,
  //   });
  // });
}

export function trackDetails(name, phone, email, companyName, path) {
  // let pageName = getPageName(path);
  // window.analytics.track(`details_form filled from ${pageName}`, {
  //   name: name,
  //   phone: phone,
  //   email: email,
  //   companyName: companyName,
  //   path: `${window.location.href}`,
  // });
  // window.analytics.ready(function () {
  //   window.analytics.identify(getCookie("ajs_user_id"), {
  //     name: name,
  //     phone: phone,
  //     email: email,
  //   });
  // });
}

export function trackNumber(phone, path) {
  // let pageName = getPageName(path);
  // window.analytics.track(`phone_form filled from ${pageName}`, {
  //   phone: phone,
  //   path: `${window.location.href}`,
  // });
  // window.analytics.ready(function () {
  //   window.analytics.identify(getCookie("ajs_user_id"), {
  //     phone: phone,
  //   });
  // });
}

export function trackCall(path) {
  // let pageName = getPageName(path);
  // window.analytics.track(`call from ${pageName}`, {
  //   path: `${window.location.href}`,
  // });
}

export function trackModal(path) {
  // let pageName = getPageName(path);
  // window.analytics.track(`modal opens from ${pageName}`, {
  //   path: `${window.location.href}`,
  // });
}

export function trackModalDetails(name, phone, email, companyName, path) {
  // let pageName = getPageName(path);
  // window.analytics.track(`modal_form filled from ${pageName}`, {
  //   name: name,
  //   phone: phone,
  //   email: email,
  //   companyName: companyName,
  //   path: `${window.location.href}`,
  // });
  // window.analytics.ready(function () {
  //   window.analytics.identify(getCookie("ajs_user_id"), {
  //     name: name,
  //     phone: phone,
  //     email: email,
  //   });
  // });
}

export function locationSelected(locationName) {
  // window.analytics.track(`form_steps`, {
  //   place: locationName,
  //   city_selected: locationName,
  //   path: `${window.location.href}`,
  // });
}

export const visitedWorkspaceClicked = (workspaceName) => {
  // window.analytics.track("Visited workspace", {
  //   workspace: workspaceName,
  //   path: `${window.location.href}`,
  // });
};

export const lazyOffset = 100;

export const handleRefreshOnError = () => {
  window.location.reload();
};

export const zohoUrlClicked = () => {
  let url =
    "https://creatorapp.zohopublic.in/preeti.yadav_workingdom/co-working-space-management/page-perma/Meeting_DayPass/PaqbadeXbOgZy3V1AO86xXNbN2tb08rQdCJBrxFZj5ppHHybPdjUWBsf3K9aZ1YByC5qG8Kx22npVE54Gp589Pq7gM1TwwEKKH9M";

  window.open(url, "_blank");
};

export const zohoUrl =
  "https://creatorapp.zohopublic.in/preeti.yadav_workingdom/co-working-space-management/page-perma/Meeting_DayPass/PaqbadeXbOgZy3V1AO86xXNbN2tb08rQdCJBrxFZj5ppHHybPdjUWBsf3K9aZ1YByC5qG8Kx22npVE54Gp589Pq7gM1TwwEKKH9M";
